import * as React from 'react';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { verticalAlign } from '../utils/customPropStyles';
import { imageError } from '../utils/imageError';

const Image = styled<any, any>('img')`
    ${propStyles};
    ${verticalAlign};
    flex-shrink: 0;
`;

interface Icon {
    theme?: any;
    dataStore?: any;
    fileName: string;
}

const Icon: React.SFC<Icon> = ({ theme, dataStore, fileName, ...props }) => (
    <Image
        src={`${dataStore.apiUrl}/${fileName}.svg`}
        onError={e => imageError(e.target)}
        {...props}
    />
);

export default inject('dataStore')(observer(withTheme(Icon))) as any;


// WEBPACK FOOTER //
// ./src/Components/Icon.tsx